import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Avatar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import converter from "../../../../Helper/convertFile";
import { hideLiveChatPopUp } from "../../../../Actions/heatSpotAction";
import Gif from "../../Messages/WebView/Gif";
import { ws } from "../../../../App";
import axiosI from "../../../../Service/service";

const styles = {
  avatar: {
    margin: 10,
    height: 60,
    width: 65,
    fontSize: 40,
  },
};

class LiveChatFooter extends React.Component {
  constructor() {
    super();
    this.state = {
      stickers: [],
      showStickers: false,
      textMessage: "",
      scroll: true,
      showCamera: false,
      showPopUp: false,
    };
  }

  componentDidMount() {
    let { stickers } = this.state;
    for (let i = 1; i <= 30; i++) {
      stickers.push(
        <div className="heatspot-sticker" onClick={() => this.sendSticker(i)}>
          <img
            src={require(`../../../../images/Stickers/${i}.png`)}
            alt={i}
            className="heatSpot-emoji-size"
          />
        </div>
      );
    }
    this.setState({
      stickers,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showPopUp && nextProps.showPopUp.showLiveChatPopUp) {
      let chatElement = document.getElementsByClassName("live-chat-panel");
      if (
        chatElement[0].clientHeight + chatElement[0].scrollTop + 5 <
        chatElement[0].scrollHeight
      ) {
        this.setState({
          showPopUp: true,
        });
        chatElement[0].addEventListener("scroll", () => {
          let scrollElement =
            document.getElementsByClassName("live-chat-panel");
          if (
            scrollElement[0].clientHeight + scrollElement[0].scrollTop + 5 >=
            scrollElement[0].scrollHeight
          ) {
            this.hidePopUp();
          }
        });
      }
    }
  }
  sendSticker = (id) => {
    let date = new Date();
    let currentDate = moment().utc().format("YYYY-MM-DD HH:mm:ss");
    let data = {
      text: "[Sticker message]",
      stickerId: `${id}.png`,
    };
    ws.json({
      msgid: date.getTime().toString().slice(4),
      chat_message: data,
      message_type: "5",
      chat_time: currentDate,
      user_id: this.props.userId.toString(),
      type: "businesschat",
      chat_type: "Business",
      token_id: localStorage.getItem("token"),
      googlePlacedId: this.props.userDetails.BusinessUser.PlaceID,
    });
  };
  showStickers = () => {
    this.setState({
      showStickers: !this.state.showStickers,
    });
    let panel = document.getElementsByClassName("live-chat-panel");
    if (!this.state.showStickers) {
      panel[0].style.height = "calc(100vh - 360px)";
    } else {
      panel[0].style.height = "calc(100vh - 360px)";
    }
  };

  onTextChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };
  convertUnicode = (input) => {
    return input.toString().replace(/\\u(\w\w\w\w)/g, (a, b) => {
      let charcode = parseInt(b, 16);
      return String.fromCharCode(charcode);
    });
  };

  handleImageChange = (e) => {
    let url = "";
    let length;
    let date = new Date();
    if (e.target.files.length > 5) {
      alert("Only 5 images can be selected per time.");
      length = 5;
    } else length = e.target.files.length;
    // debugger
    for (let i = 0; i < length; i++) {
      console.log(e.target.files[i]);
      if (e.target.files[i].type.split("/")[0] === "image") {
        converter.toBase64(e.target.files[i]).then((dt) => {
          dt = dt.substring(dt.indexOf(",") + 1);
          url = dt;
          let data = {
            ProfileImage: url,
            messageId: date.getTime().toString().slice(4),
          };
          axiosI
            .post("/UploadChatImage", data, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              if (
                response.data.results.Message !== "Chat Image does not saved"
              ) {
                let currentDate = moment().utc().format("YYYY-MM-DD HH:mm:ss");
                let data = {
                  text: "[Picture message]",
                  imgUrl: response.data.results.ImageUrl,
                };
                ws.json({
                  msgid: response.data.results.Id,
                  chat_message: data,
                  message_type: "2",
                  chat_time: currentDate,
                  user_id: this.props.userId.toString(),
                  type: "businesschat",
                  chat_type: "Business",
                  token_id: localStorage.getItem("token"),
                  googlePlacedId: this.props.userDetails.BusinessUser.PlaceID,
                });
              }
            })
            .catch((err) => {
              console.log("Error uploading image to the server.", err);
            });
        });
      } else {
        this.props.toggleAlert(
          "Please select image of png, jpg and jpeg type only."
        );
      }
    }
  };

  sendMessage = () => {
    let { textMessage } = this.state;
    if (textMessage.trim().length > 0) {
      let date = new Date();
      let currentDate = moment().utc().format("YYYY-MM-DD HH:mm:ss");
      ws.json({
        msgid: date.getTime().toString().slice(4),
        chat_message: {
          text: textMessage,
        },
        message_type: "1",
        chat_time: currentDate,
        user_id: this.props.userId.toString(),
        type: "businesschat",
        chat_type: "Business",
        token_id: localStorage.getItem("token"),
        googlePlacedId: this.props.userDetails.BusinessUser.PlaceID,
      });
      this.setState({
        textMessage: "",
      });
    }
  };

  toggleCamera = () => {
    this.setState({
      showCamera: !this.state.showCamera,
    });
  };

  onCameraClick = (image) => {
    // debugger
    if (image !== "data:,") {
      let date = new Date();
      image = image.substring(image.indexOf(",") + 1);
      let data = {
        ProfileImage: image,
        messageId: date.getTime().toString().slice(4),
      };
      axiosI
        .post("/UploadChatImage", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.results.Message !== "Chat Image does not saved") {
            let currentDate = moment().utc().format("YYYY-MM-DD HH:mm:ss");
            let data = {
              text: "[Picture message]",
              imgUrl: response.data.results.ImageUrl,
            };
            ws.json({
              msgid: date.getTime().toString().slice(4),
              chat_message: data,
              message_type: "2",
              chat_time: currentDate,
              user_id: this.props.userId.toString(),
              type: "businesschat",
              chat_type: "Business",
              token_id: localStorage.getItem("token"),
              googlePlacedId: this.props.userDetails.BusinessUser.PlaceID,
            });
          } else {
            alert("Image not able to send");
          }
        })
        .catch((err) => {
          console.log("Error uploading image to the server.", err);
        });
      this.setState({
        showCamera: false,
      });
    }
  };
  do_resize = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.sendMessage(e);
    } else {
      let el = e.target;
      setTimeout(() => {
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        if (el.scrollHeight < 120) {
          el.style.cssText = "padding:0 max-height:200px overflow-y:scroll";
          el.style.cssText = "height:" + el.scrollHeight + "px";
        }
      }, 0);
    }
  };
  hidePopUp = () => {
    this.setState({
      showPopUp: false,
    });
    this.props.hideLiveChatPopUp();
    let chatElement = document.getElementsByClassName("live-chat-panel");
    chatElement[0].scrollTop =
      chatElement[0].scrollHeight - chatElement[0].clientHeight;
  };
  render() {
    const { classes, liveChatData, toggleAlert } = this.props;
    let { stickers, showStickers, textMessage, showPopUp, showCamera } =
      this.state;
    return (
      <React.Fragment>
        {showCamera && (
          <Gif
            showCamera={this.state.showCamera}
            toggleCamera={this.toggleCamera}
            onCameraClick={this.onCameraClick}
            toggleAlert={toggleAlert}
          />
        )}
        {showPopUp && (
          <div className="live-chat-unread-pop-up" onClick={this.hidePopUp}>
            <Avatar className={classes.avatar}>
              <img
                src={require(`./../../../../images/Alphabets/${liveChatData[
                  liveChatData.length - 1
                ].First_Name.substr(0, 1).toUpperCase()}.png`)}
                height={65}
                width={65}
                alt="img"
              />
            </Avatar>
            <div className="unread-pop-up-wrapper">
              <p>{liveChatData[liveChatData.length - 1].First_Name}</p>
              <p>
                {
                  JSON.parse(
                    liveChatData[liveChatData.length - 1].CommentDetail
                  ).text
                }
              </p>
            </div>
          </div>
        )}
        <div className="live-chat-footer">
          <div className="scroll-text">
            <textarea
              onKeyDown={this.do_resize}
              cols="20"
              rows="1"
              placeholder="Type your message"
              id="textMessage"
              value={textMessage}
              onChange={this.onTextChange}
            />
          </div>
          <div className="scroll-sticker-area">
            {textMessage.trim().length > 0 ? (
              <label
                className="live-chat-send-button"
                onClick={this.sendMessage}
              >
                Send
              </label>
            ) : (
              <img
                src={require("../../../../images/Message Icons/message_Emoji_icon@3x.png")}
                alt="img"
                height={35}
                width={35}
                className="live-chat-sticker"
                onClick={this.showStickers}
              />
            )}
          </div>
        </div>
        <div id="live-chat-image-wrapper" className="live-chat-image-wrapper">
          <img
            src={require("../../../../images/Message Icons/message_photo_library@3x.png")}
            alt="img"
            height={35}
            width={40}
            onClick={() => this.refs.img.click()}
          />
          <input
            type="file"
            ref="img"
            multiple={true}
            style={{ display: "none" }}
            name="chatImage"
            title="Load File"
            onChange={(e) => {
              this.handleImageChange(e);
            }}
          />
          <img
            src={require("../../../../images/Message Icons/message_camera@3x.png")}
            alt="img"
            height={35}
            width={40}
            onClick={this.toggleCamera}
          />
        </div>
        {showStickers && <div className="show-stickers">{stickers}</div>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.loginResponse.results,
    userId: state.loginResponse.results.AppUser.UserId,
    liveChatData: state.liveChatReducer.liveChat,
    liveChatIndex: state.liveChatReducer.liveChatIndex,
    totalData: state.liveChatReducer.totalData,
    showPopUp: state.liveChatReducer,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      hideLiveChatPopUp,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(withStyles(styles)(LiveChatFooter));
